import "./style.scss";
import MultiSelect from "react-select";

const MultiSelector = (props) => {
  const {
    idValue,
    showLabel,
    hide,
    label,
    name,
    values,
    items,
    changeAction,
    optionLabelField,
    optionValueField
  } = props;

  function getOptionsFromItems(items) {
    return (items && items.length > 0) ? items.map((item) => {
      return {
        label: (optionLabelField ? item[optionLabelField] : item.label),
        value: (optionValueField ? item[optionValueField] : item.value)
      }
    }) : [];
  }

  return (
    <div className='multi-selector'>
      <div className='multi-selector-label'>
        <label id={idValue} htmlFor={idValue}><span className={(showLabel && !hide) ? '' : 'sr-hide'}>{label || name}</span></label>
      </div>
      <MultiSelect
        options={getOptionsFromItems(items)}
        onChange={changeAction}
        value={getOptionsFromItems(values)}
        className={(hide) ? 'sr-hide' : 'multi-select'}
        classNamePrefix={'multi-select'}
        isMulti/>
    </div>
  );
}

export default MultiSelector;